export const API_BASE_URL = 
    process.env.NODE_ENV === 'production'
    ? 'https://quasarvision-app-596123488451.asia-northeast3.run.app'
    : 'http://127.0.0.1:8000';